// import React, { useEffect, useMemo, useState } from 'react';
// import { Alert, Button, Form, Spinner, Table } from 'react-bootstrap';
// import { useTranslation } from 'react-i18next';

// import { useAppDispatch, useAppSelector } from '@store/hooks';

// // ✅ Thunks
// import type { ItemComponentModels } from '@store/INV/MasterItems/MasterItemsModels';
// import {
//   addItemComponent,
//   deleteItemComponentCommand,
//   getItemComponentsByItemId
// } from '@store/INV/MasterItems/ItemComponentSlice';

// // ✅ Picker (نفس المستخدم في POLines)
// import { useItemUomPicker, ItemUomPickerModal } from '@pages/INV/lookups/useItemUomPicker';

// // ✅ (اختياري) لعرض الاسم/الوحدة/الباركود بعد الاختيار
// import type { ItemWithUomRow } from '@pages/INV/lookups/itemsWithUomLookup.api';
// import { mergeIntoDetailsMap, makeDetailsKey } from '@pages/INV/lookups/itemsWithUomLookup.logic';
// import { Card } from '@components/card/card';

// type Props = {
//   ItemId: string;
// };

// const AssemblyComponents = ({ ItemId }: Props) => {
//   const { i18n, t } = useTranslation();
//   const dispatch = useAppDispatch();

//   // ✅ عدّل هذا حسب اسم reducer عندك في store
//   const { ItemComponenListByItem, loading, error } = useAppSelector((s: any) => s.ItemComponent);

//   // ✅ نحتاج InventoryId للـ picker (مثل POLines)
//   // عدّل الحقل حسب اللي عندك داخل MasterItemsById
//   const { MasterItemsById } = useAppSelector((s: any) => s.MasterItemsINV);

//   // ✅ Picker
//   const { pickItemUom, modalProps } = useItemUomPicker();

//   // ✅ Map لعرض تفاصيل (اسم الصنف والوحدة والباركود) بعد الاختيار
//   const [detailsMap, setDetailsMap] = useState<Map<string, ItemWithUomRow>>(new Map());

//   const [saving, setSaving] = useState(false);
//   const [localError, setLocalError] = useState<string | null>(null);
//   const [localSuccess, setLocalSuccess] = useState<string | null>(null);

//   const nextLineNo = useMemo(() => {
//     const maxNo = (ItemComponenListByItem || []).reduce((m: number, r: ItemComponentModels) => {
//       const n = Number(r.lineNo || 0);
//       return n > m ? n : m;
//     }, 0);
//     return maxNo + 1;
//   }, [ItemComponenListByItem]);

//   const [form, setForm] = useState<ItemComponentModels>({
//     itemId: ItemId,
//     contentItemId: '',
//     uomId: '',
//     quantity: 1,
//     lineNo: 1
//   });

//   // ✅ جلب قائمة المكونات
//   useEffect(() => {
//     if (!ItemId) return;
//     dispatch(getItemComponentsByItemId(ItemId));
//   }, [dispatch, ItemId]);

//   // ✅ تحديث الفورم عند تغيير ItemId / nextLineNo
//   useEffect(() => {
//     setForm(prev => ({
//       ...prev,
//       itemId: ItemId,
//       lineNo: nextLineNo
//     }));
//   }, [ItemId, nextLineNo]);

//   const setField = (key: keyof ItemComponentModels, value: any) => {
//     setForm(prev => ({ ...prev, [key]: value }));
//   };

//   const lineHasDuplicate = (contentItemId: string, uomId: string) => {
//     if (!contentItemId || !uomId) return false;
//     return (ItemComponenListByItem || []).some(l => {
//       return String(l.contentItemId || '') === String(contentItemId) && String(l.uomId || '') === String(uomId);
//     });
//   };

//   // ✅ فتح picker لاختيار contentItemId + uomId
//   const openPicker = async () => {
//     setLocalError(null);
//     setLocalSuccess(null);

//     const picked = await pickItemUom({
//       title: i18n.language === 'en' ? 'Pick Component Item & UOM' : 'اختيار مكون الصنف',
//       params: {
//         // InventoryId: inventoryId,
//         Scope: 1,
//         WithLastPrice: true
//       },
//       bodyDefaults: {
//         // itemType: DEFAULT_ITEM_TYPE
//       },
//       pageSize: 10,
//       searchMode: 'manual',
//       initialSearchField: 'barcodeEqual',
//       dynamicFields: ['lastCostPrice', 'uomFactor'],
//       // ✅ منع تكرار نفس المكون بنفس الوحدة
//       isDisabledRow: (r: any) => lineHasDuplicate(String(r.itemId), String(r.unitOfMeasure))
//     });

//     if (!picked) return;

//     const row: any = picked.row;
//     if (!row?.itemId || !row?.unitOfMeasure) return;

//     // ✅ منع التكرار (احتياط)
//     if (lineHasDuplicate(String(row.itemId), String(row.unitOfMeasure))) {
//       window?.alert?.(t('لا يمكن تكرار نفس الصنف بنفس الوحدة.'));
//       return;
//     }

//     // ✅ خزّن التفاصيل للعرض
//     setDetailsMap(prev => mergeIntoDetailsMap(prev, [row]));

//     // ✅ عبي contentItemId + uomId
//     setForm(prev => ({
//       ...prev,
//       contentItemId: String(row.itemId),
//       uomId: String(row.unitOfMeasure)
//     }));
//   };

//   const pickedInfo = useMemo(() => {
//     if (!form.contentItemId || !form.uomId) return null;
//     return detailsMap.get(makeDetailsKey(form.contentItemId, form.uomId)) || null;
//   }, [detailsMap, form.contentItemId, form.uomId]);

//   const pickedItemName = useMemo(() => {
//     if (!pickedInfo) return '';
//     const isEn = i18n.language === 'en';
//     return (isEn ? pickedInfo?.name || pickedInfo?.name2 : pickedInfo?.name2 || pickedInfo?.name) || '';
//   }, [pickedInfo, i18n.language]);

//   const pickedUomName = useMemo(() => {
//     if (!pickedInfo) return '';
//     const isEn = i18n.language === 'en';
//     return (
//       (isEn
//         ? pickedInfo?.unitOfMeasureName || pickedInfo?.unitOfMeasureName2
//         : pickedInfo?.unitOfMeasureName2 || pickedInfo?.unitOfMeasureName) || ''
//     );
//   }, [pickedInfo, i18n.language]);

//   const validate = () => {
//     if (!form.contentItemId || !form.uomId) return t('اختر الصنف والوحدة أولاً');
//     if (!form.quantity || Number(form.quantity) <= 0) return t('الكمية يجب أن تكون أكبر من صفر');
//     return null;
//   };

//   const handleAdd = async () => {
//     setLocalError(null);
//     setLocalSuccess(null);

//     const msg = validate();
//     if (msg) {
//       setLocalError(String(msg));
//       return;
//     }

//     setSaving(true);
//     try {
//       const payload: ItemComponentModels = {
//         itemId: ItemId,
//         contentItemId: String(form.contentItemId),
//         uomId: String(form.uomId),
//         quantity: Number(form.quantity),
//         lineNo: Number(nextLineNo) // ✅ lineNo تلقائي
//       };

//       const res: any = await dispatch(addItemComponent(payload)).unwrap();

//       if (res?.succeeded === false) {
//         setLocalError(res?.message || 'فشل إضافة المكوّن');
//       } else {
//         setLocalSuccess(t('SavedSuccessfully') || 'تم الحفظ بنجاح');
//         await dispatch(getItemComponentsByItemId(ItemId));

//         // ✅ reset: صِفّر الاختيار وارجع lineNo تلقائي جديد
//         setForm(prev => ({
//           ...prev,
//           contentItemId: '',
//           uomId: '',
//           quantity: 1,
//           lineNo: nextLineNo + 1
//         }));
//       }
//     } catch (e: any) {
//       setLocalError(e?.message || String(e) || 'حدث خطأ أثناء الحفظ');
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleDelete = async (row: ItemComponentModels) => {
//     setLocalError(null);
//     setLocalSuccess(null);

//     if (!row?.id) {
//       setLocalError('لا يمكن حذف سطر بدون معرف (id)');
//       return;
//     }

//     const ok = window.confirm(t('ConfirmDelete') || 'هل أنت متأكد من الحذف؟');
//     if (!ok) return;

//     setSaving(true);
//     try {
//       const res: any = await dispatch(deleteItemComponentCommand({ id: row.id })).unwrap();

//       if (res?.succeeded === false) {
//         setLocalError(res?.message || 'فشل الحذف');
//       } else {
//         setLocalSuccess(t('DeletedSuccessfully') || 'تم الحذف بنجاح');
//         await dispatch(getItemComponentsByItemId(ItemId));
//       }
//     } catch (e: any) {
//       setLocalError(e?.message || String(e) || 'حدث خطأ أثناء الحذف');
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <div>
//       {/* ✅ Modal مرة واحدة */}
//       <ItemUomPickerModal {...modalProps} />

//       {(error || localError) && (
//         <Alert variant='danger' className='mb-3'>
//           {String(localError || error)}
//         </Alert>
//       )}
//       {localSuccess && (
//         <Alert variant='success' className='mb-3'>
//           {localSuccess}
//         </Alert>
//       )}

//       {/* ✅ شريط الإضافة */}

//       <Card>
//         <div className='mb-3 p-3  '>
//           {/* اختيار الصنف + عرض التفاصيل */}
//           <div className='p-2 border rounded bg-body mb-2'>
//             <div className='d-flex align-items-start gap-2'>
//               <div className='flex-grow-1' style={{ minWidth: 0 }}>
//                 {form.contentItemId ? (
//                   <>
//                     <div className='fw-bold text-truncate'>{pickedItemName || form.contentItemId}</div>
//                     <small className='text-muted d-block'>
//                       {t('الوحدة')}: <span className='fw-bold text-theme'>{pickedUomName || form.uomId}</span>
//                       <span className='mx-2'>•</span>
//                       {t('باركود')}: <span className='fw-bold'>{pickedInfo?.barcode || '-'}</span>
//                     </small>
//                   </>
//                 ) : (
//                   <div className='text-muted'>{t('اختر الصنف المكوّن')}</div>
//                 )}
//               </div>

//               <div className='d-flex gap-1'>
//                 <Button variant='primary' size='sm' onClick={openPicker} disabled={saving || loading}>
//                   <i className='fas fa-search me-1'></i>
//                   {form.contentItemId ? t('تغيير') : t('اختيار')}
//                 </Button>

//                 {form.contentItemId && (
//                   <Button
//                     variant='outline-danger'
//                     size='sm'
//                     onClick={() => setForm(prev => ({ ...prev, contentItemId: '', uomId: '' }))}
//                     disabled={saving || loading}
//                   >
//                     <i className='fas fa-times'></i>
//                   </Button>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* lineNo + qty */}
//           <div className='row g-2'>
//             <div className='col-md-3'>
//               <div className='input-group input-group-sm'>
//                 <span className='input-group-text'>
//                   <Form.Label className='mb-1'>{t('Quantity') || 'الكمية'}</Form.Label>
//                 </span>
//                 <Form.Control
//                   type='number'
//                   min={0}
//                   step='0.0001'
//                   value={form.quantity ?? 1}
//                   onChange={e => setField('quantity', Number(e.target.value))}
//                   disabled={!form.contentItemId || saving || loading}
//                 />
//               </div>
//             </div>

//             <div className='col-md-9 d-flex align-items-end justify-content-end'>
//               <Button
//                 variant='success'
//                 onClick={handleAdd}
//                 disabled={!form.contentItemId || !form.uomId || saving || loading}
//               >
//                 {saving ? t('Saving') || 'جاري الحفظ...' : t('Add') || 'إضافة'}
//               </Button>
//             </div>
//           </div>
//         </div>
//       </Card>

//       {/* ✅ جدول المكونات */}
//       <Table responsive bordered hover size='sm' className='mb-0'>
//         <thead>
//           <tr>
//             <th style={{ width: 80 }}>{t('LineNo') || 'سطر'}</th>
//             <th>{t('ContentItem') || 'الصنف المكوّن'}</th>
//             <th>{t('Uom') || 'الوحدة'}</th>
//             <th style={{ width: 140 }}>{t('Quantity') || 'الكمية'}</th>
//             <th style={{ width: 120 }}>{t('Actions') || 'إجراءات'}</th>
//           </tr>
//         </thead>
//         <tbody>
//           {(ItemComponenListByItem || []).length === 0 ? (
//             <tr>
//               <td colSpan={5} className='text-center py-4 text-muted'>
//                 {t('NoData') || 'لا توجد بيانات'}
//               </td>
//             </tr>
//           ) : (
//             (ItemComponenListByItem || [])
//               .slice()
//               .sort((a: any, b: any) => Number(a.lineNo || 0) - Number(b.lineNo || 0))
//               .map((row: ItemComponentModels, idx: number) => (
//                 <tr key={row.id || idx}>
//                   <td className='text-center'>{row.lineNo}</td>
//                   <td className='text-break'>{row.contentItemId}</td>
//                   <td className='text-break'>{row.uomId}</td>
//                   <td className='text-end'>{row.quantity}</td>
//                   <td className='text-center'>
//                     <Button
//                       variant='outline-danger'
//                       size='sm'
//                       onClick={() => handleDelete(row)}
//                       disabled={saving || loading}
//                     >
//                       {t('Delete') || 'حذف'}
//                     </Button>
//                   </td>
//                 </tr>
//               ))
//           )}
//         </tbody>
//       </Table>
//     </div>
//   );
// };

// export default AssemblyComponents;

// import { useEffect, useMemo, useState } from 'react';
// import { Alert, Button, Form, Spinner, Table } from 'react-bootstrap';
// import { useTranslation } from 'react-i18next';
// import { useAppDispatch, useAppSelector } from '@store/hooks';

// // ✅ Thunks
// import type { ItemComponentModels } from '@store/INV/MasterItems/MasterItemsModels';
// import {
//   addItemComponent,
//   deleteItemComponentCommand,
//   getItemComponentsByItemId
// } from '@store/INV/MasterItems/ItemComponentSlice';

// // ✅ Picker (نفس المستخدم في POLines)
// import { useItemUomPicker, ItemUomPickerModal } from '@pages/INV/lookups/useItemUomPicker';

// // ✅ (اختياري) لعرض الاسم/الوحدة/الباركود بعد الاختيار
// import type { ItemWithUomRow } from '@pages/INV/lookups/itemsWithUomLookup.api';
// import { mergeIntoDetailsMap, makeDetailsKey } from '@pages/INV/lookups/itemsWithUomLookup.logic';
// import { Card } from '@components/card/card';
// import Loading from '@components/Shared/Loader/Loading';
// import Pagination from '@components/Shared/Pagination/Pagination';

// type Props = {
//   ItemId: string;
// };

// const AssemblyComponents = ({ ItemId }: Props) => {
//   const { i18n, t } = useTranslation();
//   const dispatch = useAppDispatch();

//   // ✅ Store selectors
//   const { ItemComponenListByItem, loading, error } = useAppSelector((s: any) => s.ItemComponent);
//   const { MasterItemsById } = useAppSelector((s: any) => s.MasterItemsINV);

//   // ✅ Picker
//   const { pickItemUom, modalProps } = useItemUomPicker();

//   // ✅ Map لعرض تفاصيل (اسم الصنف والوحدة والباركود) بعد الاختيار
//   const [detailsMap, setDetailsMap] = useState<Map<string, ItemWithUomRow>>(new Map());

//   const [saving, setSaving] = useState(false);
//   const [localError, setLocalError] = useState<string | null>(null);
//   const [localSuccess, setLocalSuccess] = useState<string | null>(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [dataPerPage] = useState(5);

//   const nextLineNo = useMemo(() => {
//     const maxNo = (ItemComponenListByItem || []).reduce((m: number, r: ItemComponentModels) => {
//       const n = Number(r.lineNo || 0);
//       return n > m ? n : m;
//     }, 0);
//     return maxNo + 1;
//   }, [ItemComponenListByItem]);

//   const [form, setForm] = useState<ItemComponentModels>({
//     itemId: ItemId,
//     contentItemId: '',
//     uomId: '',
//     quantity: 1,
//     lineNo: 1
//   });

//   // ✅ جلب قائمة المكونات
//   useEffect(() => {
//     if (!ItemId) return;
//     dispatch(getItemComponentsByItemId(ItemId));
//   }, [dispatch, ItemId]);

//   // ✅ تحديث الفورم عند تغيير ItemId / nextLineNo
//   useEffect(() => {
//     setForm(prev => ({
//       ...prev,
//       itemId: ItemId,
//       lineNo: nextLineNo
//     }));
//   }, [ItemId, nextLineNo]);

//   const setField = (key: keyof ItemComponentModels, value: any) => {
//     setForm(prev => ({ ...prev, [key]: value }));
//   };

//   const lineHasDuplicate = (contentItemId: string, uomId: string) => {
//     if (!contentItemId || !uomId) return false;
//     return (ItemComponenListByItem || []).some((l: any) => {
//       return String(l.contentItemId || '') === String(contentItemId) && String(l.uomId || '') === String(uomId);
//     });
//   };

//   // ✅ فتح picker لاختيار contentItemId + uomId
//   const openPicker = async () => {
//     setLocalError(null);
//     setLocalSuccess(null);

//     const picked = await pickItemUom({
//       title: i18n.language === 'en' ? 'Pick Component Item & UOM' : 'اختيار مكون الصنف',
//       params: {
//         Scope: 1,
//         WithLastPrice: true
//       },
//       bodyDefaults: {},
//       pageSize: 10,
//       searchMode: 'manual',
//       initialSearchField: 'barcodeEqual',
//       dynamicFields: ['lastCostPrice', 'uomFactor'],
//       // ✅ منع تكرار نفس المكون بنفس الوحدة
//       isDisabledRow: (r: any) => lineHasDuplicate(String(r.itemId), String(r.unitOfMeasure))
//     });

//     if (!picked) return;

//     const row: any = picked.row;
//     if (!row?.itemId || !row?.unitOfMeasure) return;

//     // ✅ منع التكرار (احتياط)
//     if (lineHasDuplicate(String(row.itemId), String(row.unitOfMeasure))) {
//       window?.alert?.(t('لا يمكن تكرار نفس الصنف بنفس الوحدة.'));
//       return;
//     }

//     // ✅ خزّن التفاصيل للعرض
//     setDetailsMap(prev => mergeIntoDetailsMap(prev, [row]));

//     // ✅ عبي contentItemId + uomId
//     setForm(prev => ({
//       ...prev,
//       contentItemId: String(row.itemId),
//       uomId: String(row.unitOfMeasure)
//     }));
//   };

//   const pickedInfo = useMemo(() => {
//     if (!form.contentItemId || !form.uomId) return null;
//     return detailsMap.get(makeDetailsKey(form.contentItemId, form.uomId)) || null;
//   }, [detailsMap, form.contentItemId, form.uomId]);

//   const pickedItemName = useMemo(() => {
//     if (!pickedInfo) return '';
//     const isEn = i18n.language === 'en';
//     return (isEn ? pickedInfo?.name || pickedInfo?.name2 : pickedInfo?.name2 || pickedInfo?.name) || '';
//   }, [pickedInfo, i18n.language]);

//   const pickedUomName = useMemo(() => {
//     if (!pickedInfo) return '';
//     const isEn = i18n.language === 'en';
//     return (
//       (isEn
//         ? pickedInfo?.unitOfMeasureName || pickedInfo?.unitOfMeasureName2
//         : pickedInfo?.unitOfMeasureName2 || pickedInfo?.unitOfMeasureName) || ''
//     );
//   }, [pickedInfo, i18n.language]);

//   const validate = () => {
//     if (!form.contentItemId || !form.uomId) return t('اختر الصنف والوحدة أولاً');
//     if (!form.quantity || Number(form.quantity) <= 0) return t('الكمية يجب أن تكون أكبر من صفر');
//     return null;
//   };

//   const handleAdd = async () => {
//     setLocalError(null);
//     setLocalSuccess(null);

//     const msg = validate();
//     if (msg) {
//       setLocalError(String(msg));
//       return;
//     }

//     setSaving(true);
//     try {
//       const payload: ItemComponentModels = {
//         itemId: ItemId,
//         contentItemId: String(form.contentItemId),
//         uomId: String(form.uomId),
//         quantity: Number(form.quantity),
//         lineNo: Number(nextLineNo) // ✅ lineNo تلقائي
//       };

//       const res: any = await dispatch(addItemComponent(payload)).unwrap();

//       if (res?.succeeded === false) {
//         setLocalError(res?.message || 'فشل إضافة المكوّن');
//       } else {
//         setLocalSuccess(t('SavedSuccessfully') || 'تم الحفظ بنجاح');
//         await dispatch(getItemComponentsByItemId(ItemId));

//         // ✅ reset: صِفّر الاختيار وارجع lineNo تلقائي جديد
//         setForm(prev => ({
//           ...prev,
//           contentItemId: '',
//           uomId: '',
//           quantity: 1,
//           lineNo: nextLineNo + 1
//         }));
//       }
//     } catch (e: any) {
//       setLocalError(e?.message || String(e) || 'حدث خطأ أثناء الحفظ');
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleDelete = async (row: ItemComponentModels) => {
//     setLocalError(null);
//     setLocalSuccess(null);

//     if (!row?.id) {
//       setLocalError('لا يمكن حذف سطر بدون معرف (id)');
//       return;
//     }

//     const ok = window.confirm(t('ConfirmDelete') || 'هل أنت متأكد من الحذف؟');
//     if (!ok) return;

//     setSaving(true);
//     try {
//       const res: any = await dispatch(deleteItemComponentCommand({ id: row.id })).unwrap();

//       if (res?.succeeded === false) {
//         setLocalError(res?.message || 'فشل الحذف');
//       } else {
//         setLocalSuccess(t('DeletedSuccessfully') || 'تم الحذف بنجاح');
//         await dispatch(getItemComponentsByItemId(ItemId));
//       }
//     } catch (e: any) {
//       setLocalError(e?.message || String(e) || 'حدث خطأ أثناء الحذف');
//     } finally {
//       setSaving(false);
//     }
//   };

//   // ✅ الحصول على تفاصيل الصنف من الخريطة
//   const getItemDetails = (itemId: string, uomId: string) => {
//     return detailsMap.get(makeDetailsKey(itemId, uomId));
//   };

//   // ✅ تصفية البيانات حسب البحث
//   const filteredList = useMemo(() => {
//     if (!searchTerm) return ItemComponenListByItem || [];

//     const term = searchTerm.toLowerCase();
//     return (ItemComponenListByItem || []).filter((item: ItemComponentModels) => {
//       const details = getItemDetails(item.contentItemId, item.uomId);
//       const itemName =
//         i18n.language === 'en' ? details?.name || details?.name2 || '' : details?.name2 || details?.name || '';

//       return (
//         String(item.contentItemId || '')
//           .toLowerCase()
//           .includes(term) ||
//         String(item.uomId || '')
//           .toLowerCase()
//           .includes(term) ||
//         itemName.toLowerCase().includes(term) ||
//         (details?.barcode || '').toLowerCase().includes(term)
//       );
//     });
//   }, [ItemComponenListByItem, searchTerm, i18n.language, detailsMap]);

//   // ✅ Pagination
//   const indexOfLastItem = currentPage * dataPerPage;
//   const indexOfFirstItem = indexOfLastItem - dataPerPage;
//   const currentList = filteredList.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredList.length / dataPerPage);

//   const handlePagination = (pageNumber: number) => {
//     setCurrentPage(pageNumber);
//   };

//   const clearSearch = () => {
//     setSearchTerm('');
//     setCurrentPage(1);
//   };

//   return (
//     <div>
//       {/* ✅ Modal مرة واحدة */}
//       <ItemUomPickerModal {...modalProps} />

//       {(error || localError) && (
//         <Alert variant='danger' className='mb-3'>
//           {String(localError || error)}
//         </Alert>
//       )}
//       {localSuccess && (
//         <Alert variant='success' className='mb-3'>
//           {localSuccess}
//         </Alert>
//       )}

//       {/* ✅ Card لإضافة مكون جديد */}
//       <Card className='mb-2'>
//         <div className='card-header d-flex flex-column flex-md-row gap-2 justify-content-between align-items-start align-items-md-center'>
//           <h6 className='mb-0'>
//             <i className='fas fa-puzzle-piece me-2'></i>
//             {t('إضافة مكون جديد')}
//           </h6>
//         </div>

//         <div className='card-body'>
//           {/* اختيار الصنف + عرض التفاصيل */}
//           <div className='p-3 border rounded bg-body mb-3'>
//             <div className='d-flex align-items-start gap-2'>
//               <div className='flex-grow-1' style={{ minWidth: 0 }}>
//                 {form.contentItemId ? (
//                   <>
//                     <div className='fw-bold text-truncate'>{pickedItemName || form.contentItemId}</div>
//                     <small className='text-muted d-block'>
//                       {t('الوحدة')}: <span className='fw-bold text-theme'>{pickedUomName || form.uomId}</span>
//                       <span className='mx-2'>•</span>
//                       {t('باركود')}: <span className='fw-bold'>{pickedInfo?.barcode || '-'}</span>
//                     </small>
//                   </>
//                 ) : (
//                   <div className='text-muted'>
//                     <i className='fas fa-box-open me-2'></i>
//                     {t('اختر الصنف المكوّن')}
//                   </div>
//                 )}
//               </div>

//               <div className='d-flex gap-2'>
//                 <Button variant='primary' size='sm' onClick={openPicker} disabled={saving || loading}>
//                   <i className='fas fa-search me-1'></i>
//                   {form.contentItemId ? t('تغيير') : t('اختيار')}
//                 </Button>

//                 {form.contentItemId && (
//                   <Button
//                     variant='outline-danger'
//                     size='sm'
//                     onClick={() => setForm(prev => ({ ...prev, contentItemId: '', uomId: '' }))}
//                     disabled={saving || loading}
//                     title={t('مسح')}
//                   >
//                     <i className='fas fa-times'></i>
//                   </Button>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* lineNo + qty */}
//           <div className='row g-3'>
//             <div className='col-md-4'>
//               <div className='input-group input-group-sm'>
//                 <span className='input-group-text'>الكميــة</span>
//                 <Form.Control
//                   type='number'
//                   min={0}
//                   step='0.0001'
//                   value={form.quantity ?? 1}
//                   onChange={e => setField('quantity', Number(e.target.value))}
//                   disabled={!form.contentItemId || saving || loading}
//                   placeholder={t('الكمية')}
//                 />
//               </div>
//             </div>

//             <div className='col-md-8 d-flex align-items-end justify-content-end'>
//               <Button
//                 variant='success'
//                 onClick={handleAdd}
//                 disabled={!form.contentItemId || !form.uomId || saving || loading}
//                 className='btn-theme'
//               >
//                 {saving ? (
//                   <>
//                     <Spinner animation='border' size='sm' className='me-2' />
//                     {t('Saving') || 'جاري الحفظ...'}
//                   </>
//                 ) : (
//                   <>
//                     <i className='fas fa-plus-circle me-1'></i>
//                     {t('Add') || 'إضافة'}
//                   </>
//                 )}
//               </Button>
//             </div>
//           </div>
//         </div>
//       </Card>

//       {/* ✅ جدول المكونات */}
//       <Card className='mb-4'>
//         {/* Card Header مع البحث */}

//         <Loading loading={loading} error={error}>
//           <div className='card-body p-0'>
//             <div className='table-responsive'>
//               <table className='table table-hover mb-0'>
//                 <thead className='bg-theme bg-opacity-30 fw-bold'>
//                   <tr>
//                     <th className='small'>{t('الصنف المكوّن')}</th>
//                     <th className='small'>{t('الوحدة')}</th>
//                     <th className='small text-end' style={{ width: '140px' }}>
//                       {t('الكمية')}
//                     </th>
//                     <th className='small text-end' style={{ width: '120px' }}>
//                       {t('الإجراءات')}
//                     </th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {currentList.length > 0 ? (
//                     currentList.map((row: ItemComponentModels, idx: number) => {
//                       const details = getItemDetails(row.contentItemId, row.uomId);
//                       const itemName = i18n.language === 'en' ? row?.contentItemName : row?.contentItemName2;
//                       const uomName = i18n.language === 'en' ? row?.uomName : row?.uomName2;

//                       return (
//                         <tr key={row.id || idx}>
//                           <td className='align-middle'>
//                             <div className='d-flex align-items-center'>
//                               <div className='fw-bold'>{itemName}</div>
//                               {details?.barcode && (
//                                 <small className='text-muted'>
//                                   <i className='fas fa-barcode me-1'></i>
//                                   {details.barcode}
//                                 </small>
//                               )}
//                             </div>
//                           </td>

//                           <td className='align-middle'>{uomName}</td>

//                           <td className='align-middle text-end'>
//                             <span className='fw-bold text-primary fs-6'>{Number(row.quantity).toFixed(4)}</span>
//                           </td>

//                           <td className='align-middle text-end'>
//                             <Button
//                               variant='outline-danger'
//                               size='sm'
//                               onClick={() => handleDelete(row)}
//                               disabled={saving || loading}
//                               title={t('حذف')}
//                               className='btn-sm'
//                             >
//                               <i className='fas fa-trash'></i>
//                             </Button>
//                           </td>
//                         </tr>
//                       );
//                     })
//                   ) : (
//                     <tr>
//                       <td colSpan={5} className='text-center py-4 text-muted'>
//                         <i className='fas fa-inbox fa-2x mb-2'></i>
//                         <br />
//                         {searchTerm ? t('لا توجد نتائج للبحث') : t('لا توجد مكونات مضافة')}
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </Loading>

//         {/* ✅ Pagination في الـ Footer */}
//         {filteredList.length > 0 && (
//           <div className='card-footer'>
//             <Pagination
//               filteredData={filteredList}
//               dataPerPage={dataPerPage}
//               handlePagination={handlePagination}
//               currentPage={currentPage}
//             />
//           </div>
//         )}
//       </Card>
//     </div>
//   );
// };

// export default AssemblyComponents;

import React, { useEffect, useMemo, useState } from 'react';
import { Alert, Button, Form, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import { useAppDispatch, useAppSelector } from '@store/hooks';

// ✅ Thunks
import type { ItemComponentModels } from '@store/INV/MasterItems/MasterItemsModels';
import {
  addItemComponent,
  deleteItemComponentCommand,
  getItemComponentsByItemId
} from '@store/INV/MasterItems/ItemComponentSlice';

// ✅ Picker
import { useItemUomPicker, ItemUomPickerModal } from '@pages/INV/lookups/useItemUomPicker';

// ✅ Details map
import type { ItemWithUomRow } from '@pages/INV/lookups/itemsWithUomLookup.api';
import { mergeIntoDetailsMap, makeDetailsKey } from '@pages/INV/lookups/itemsWithUomLookup.logic';

import { Card } from '@components/card/card';
import Loading from '@components/Shared/Loader/Loading';
import Pagination from '@components/Shared/Pagination/Pagination';
import confirmAction from '@components/Shared/Alert/confirmAction';
import CustomAlert from '@components/Shared/Alert/CustomAlert';

type Props = {
  ItemId: string;
};

type FormValues = {
  itemId: string;
  contentItemId: string;
  uomId: string;
  quantity: number;
};

const AssemblyComponents = ({ ItemId }: Props) => {
  const { i18n, t } = useTranslation();
  const dispatch = useAppDispatch();

  // ✅ Store selectors
  const { ItemComponenListByItem, loading, error } = useAppSelector((s: any) => s.ItemComponent);

  // ✅ Picker
  const { pickItemUom, modalProps } = useItemUomPicker();

  // ✅ Details map
  const [detailsMap, setDetailsMap] = useState<Map<string, ItemWithUomRow>>(new Map());

  // ✅ Local UI state
  const [savingDelete, setSavingDelete] = useState(false);
  const [localError, setLocalError] = useState<string | null>(null);
  const [localSuccess, setLocalSuccess] = useState<string | null>(null);

  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage] = useState(5);

  // ✅ next line no
  const nextLineNo = useMemo(() => {
    const maxNo = (ItemComponenListByItem || []).reduce((m: number, r: ItemComponentModels) => {
      const n = Number((r as any).lineNo || 0);
      return n > m ? n : m;
    }, 0);
    return maxNo + 1;
  }, [ItemComponenListByItem]);

  // ✅ Fetch components
  useEffect(() => {
    if (!ItemId) return;
    dispatch(getItemComponentsByItemId(ItemId));
  }, [dispatch, ItemId]);

  // ✅ Reset UI state when ItemId changes
  useEffect(() => {
    setLocalError(null);
    setLocalSuccess(null);
    setSearchTerm('');
    setCurrentPage(1);
    setDetailsMap(new Map());
  }, [ItemId]);

  const lineHasDuplicate = (contentItemId: string, uomId: string) => {
    if (!contentItemId || !uomId) return false;
    return (ItemComponenListByItem || []).some((l: any) => {
      return String(l.contentItemId || '') === String(contentItemId) && String(l.uomId || '') === String(uomId);
    });
  };

  // ✅ Formik
  const formik = useFormik<FormValues>({
    enableReinitialize: true,
    initialValues: {
      itemId: ItemId,
      contentItemId: '',
      uomId: '',
      quantity: 1
    },
    validate: values => {
      const errors: Partial<Record<keyof FormValues, string>> = {};

      if (!values.contentItemId || !values.uomId) {
        errors.contentItemId = t('اختر الصنف والوحدة أولاً') as any;
      }

      if (!values.quantity || Number(values.quantity) <= 0) {
        errors.quantity = t('الكمية يجب أن تكون أكبر من صفر') as any;
      }

      if (values.contentItemId && values.uomId && lineHasDuplicate(values.contentItemId, values.uomId)) {
        errors.contentItemId = t('لا يمكن تكرار نفس الصنف بنفس الوحدة.') as any;
      }

      return errors;
    },
    onSubmit: async (values, helpers) => {
      setLocalError(null);
      setLocalSuccess(null);

      try {
        const payload: ItemComponentModels = {
          itemId: ItemId,
          contentItemId: String(values.contentItemId),
          uomId: String(values.uomId),
          quantity: Number(values.quantity),
          lineNo: Number(nextLineNo) // ✅ lineNo تلقائي وقت الإرسال
        } as any;

        const res: any = await dispatch(addItemComponent(payload)).unwrap();

        if (res?.succeeded === false) {
          CustomAlert({ msg: 'فشل إضافة المكوّن', action: 'Error' });
          return;
        }

        CustomAlert({ msg: 'تم الحفظ بنجاح', action: 'Add' });

        await dispatch(getItemComponentsByItemId(ItemId));

        // ✅ Reset form
        helpers.resetForm({
          values: { itemId: ItemId, contentItemId: '', uomId: '', quantity: 1 }
        });
      } catch (e: any) {
        setLocalError(e?.message || String(e) || 'حدث خطأ أثناء الحفظ');
      } finally {
        helpers.setSubmitting(false);
      }
    }
  });

  const isBusy = loading || savingDelete || formik.isSubmitting;

  // ✅ Open picker
  const openPicker = async () => {
    setLocalError(null);
    setLocalSuccess(null);

    const picked = await pickItemUom({
      title: i18n.language === 'en' ? 'Pick Component Item & UOM' : 'اختيار مكون الصنف',
      params: {
        Scope: 1,
        WithLastPrice: true
      },
      bodyDefaults: {},
      pageSize: 10,
      searchMode: 'manual',
      initialSearchField: 'barcodeEqual',
      dynamicFields: ['lastCostPrice', 'uomFactor'],
      isDisabledRow: (r: any) => lineHasDuplicate(String(r.itemId), String(r.unitOfMeasure))
    });

    if (!picked) return;

    const row: any = picked.row;
    if (!row?.itemId || !row?.unitOfMeasure) return;

    // ✅ Prevent duplicate (extra safety)
    if (lineHasDuplicate(String(row.itemId), String(row.unitOfMeasure))) {
      window?.alert?.(t('لا يمكن تكرار نفس الصنف بنفس الوحدة.'));
      return;
    }

    // ✅ Store details for display
    setDetailsMap(prev => mergeIntoDetailsMap(prev, [row]));

    // ✅ Fill formik values
    await formik.setFieldValue('contentItemId', String(row.itemId));
    await formik.setFieldValue('uomId', String(row.unitOfMeasure));
  };

  const pickedInfo = useMemo(() => {
    if (!formik.values.contentItemId || !formik.values.uomId) return null;
    return detailsMap.get(makeDetailsKey(formik.values.contentItemId, formik.values.uomId)) || null;
  }, [detailsMap, formik.values.contentItemId, formik.values.uomId]);

  const pickedItemName = useMemo(() => {
    if (!pickedInfo) return '';
    const isEn = i18n.language === 'en';
    return (isEn ? pickedInfo?.name || pickedInfo?.name2 : pickedInfo?.name2 || pickedInfo?.name) || '';
  }, [pickedInfo, i18n.language]);

  const pickedUomName = useMemo(() => {
    if (!pickedInfo) return '';
    const isEn = i18n.language === 'en';
    return (
      (isEn
        ? pickedInfo?.unitOfMeasureName || pickedInfo?.unitOfMeasureName2
        : pickedInfo?.unitOfMeasureName2 || pickedInfo?.unitOfMeasureName) || ''
    );
  }, [pickedInfo, i18n.language]);

  const handleDelete = async (row: ItemComponentModels) => {
    setLocalError(null);
    setLocalSuccess(null);

    if (!(row as any)?.id) {
      setLocalError('لا يمكن حذف سطر بدون معرف (id)');
      return;
    }

    const isConfrim = await confirmAction('هل أنت متأكد من الحذف؟');

    if (!isConfrim) return;

    setSavingDelete(true);
    try {
      const body = {
        itemId: ItemId,
        contentItemId: row.contentItemId
      };

      const res: any = await dispatch(deleteItemComponentCommand(body)).unwrap();

      if (res?.succeeded === false) {
        setLocalError(res?.message || 'فشل الحذف');
      } else {
        CustomAlert({ msg: 'تم الحذف بنجاح', action: 'Add' });
        await dispatch(getItemComponentsByItemId(ItemId));
      }
    } catch (e: any) {
      setLocalError(e?.message || String(e) || 'حدث خطأ أثناء الحذف');
    } finally {
      setSavingDelete(false);
    }
  };

  const getItemDetails = (itemId: string, uomId: string) => {
    return detailsMap.get(makeDetailsKey(itemId, uomId));
  };

  // ✅ Filter list
  const filteredList = useMemo(() => {
    if (!searchTerm) return ItemComponenListByItem || [];

    const term = searchTerm.toLowerCase();
    return (ItemComponenListByItem || []).filter((item: ItemComponentModels) => {
      const details = getItemDetails((item as any).contentItemId, (item as any).uomId);
      const itemName =
        i18n.language === 'en' ? details?.name || details?.name2 || '' : details?.name2 || details?.name || '';

      return (
        String((item as any).contentItemId || '')
          .toLowerCase()
          .includes(term) ||
        String((item as any).uomId || '')
          .toLowerCase()
          .includes(term) ||
        itemName.toLowerCase().includes(term) ||
        (details?.barcode || '').toLowerCase().includes(term)
      );
    });
  }, [ItemComponenListByItem, searchTerm, i18n.language, detailsMap]);

  // ✅ Pagination
  const indexOfLastItem = currentPage * dataPerPage;
  const indexOfFirstItem = indexOfLastItem - dataPerPage;
  const currentList = filteredList.slice(indexOfFirstItem, indexOfLastItem);

  const handlePagination = (pageNumber: number) => setCurrentPage(pageNumber);
  const clearSearch = () => {
    setSearchTerm('');
    setCurrentPage(1);
  };

  return (
    <div>
      {/* ✅ Modal once */}
      <ItemUomPickerModal {...modalProps} />

      {(error || localError) && (
        <Alert variant='danger' className='mb-3'>
          {String(localError || error)}
        </Alert>
      )}
      {localSuccess && (
        <Alert variant='success' className='mb-3'>
          {localSuccess}
        </Alert>
      )}

      {/* ✅ Card: Add new component (Formik) */}
      <Card className='mb-2'>
        <div className='card-body'>
          <Form onSubmit={formik.handleSubmit}>
            {/* Picker box */}
            <div className='p-3 border rounded bg-body mb-3'>
              <div className='d-flex align-items-start gap-2'>
                <div className='flex-grow-1' style={{ minWidth: 0 }}>
                  {formik.values.contentItemId ? (
                    <>
                      <div className='fw-bold text-truncate'>{pickedItemName || formik.values.contentItemId}</div>
                      <small className='text-muted d-block'>
                        {t('الوحدة')}:{' '}
                        <span className='fw-bold text-theme'>{pickedUomName || formik.values.uomId}</span>
                        <span className='mx-2'>•</span>
                        {t('باركود')}: <span className='fw-bold'>{pickedInfo?.barcode || '-'}</span>
                      </small>
                    </>
                  ) : (
                    <div className='text-muted'>
                      <i className='fas fa-box-open me-2'></i>
                      {t('اختر الصنف المكوّن')}
                    </div>
                  )}

                  {/* ✅ inline validation for selection */}
                  {formik.submitCount > 0 && formik.errors.contentItemId && (
                    <small className='text-danger d-block mt-2'>{formik.errors.contentItemId}</small>
                  )}
                </div>

                <div className='d-flex gap-2'>
                  <Button variant='outline-theme' size='sm' onClick={openPicker} disabled={isBusy}>
                    <i className='fas fa-search me-1'></i>
                    {formik.values.contentItemId ? t('تغيير') : t('اختيار')}
                  </Button>

                  {formik.values.contentItemId && (
                    <Button
                      variant='outline-danger'
                      size='sm'
                      onClick={() => {
                        formik.setFieldValue('contentItemId', '');
                        formik.setFieldValue('uomId', '');
                      }}
                      disabled={isBusy}
                      title={t('مسح') as any}
                    >
                      <i className='fas fa-times'></i>
                    </Button>
                  )}
                </div>
              </div>
            </div>

            {/* Qty + Submit */}
            <div className='row g-3'>
              <div className='col-md-4'>
                <div className='input-group input-group-sm'>
                  <span className='input-group-text'>الكميــة</span>
                  <Form.Control
                    name='quantity'
                    type='number'
                    min={0}
                    step='0.0001'
                    value={formik.values.quantity ?? 1}
                    onChange={e => formik.setFieldValue('quantity', Number(e.target.value))}
                    disabled={!formik.values.contentItemId || isBusy}
                    placeholder={t('الكمية') as any}
                  />
                </div>
                {formik.submitCount > 0 && formik.errors.quantity && (
                  <small className='text-danger d-block mt-1'>{formik.errors.quantity}</small>
                )}
              </div>

              <div className='col-md-8 d-flex align-items-end justify-content-end'>
                <Button
                  type='submit'
                  variant='success'
                  disabled={!formik.values.contentItemId || !formik.values.uomId || isBusy}
                  className='btn-theme'
                >
                  {formik.isSubmitting ? (
                    <>
                      <Spinner animation='border' size='sm' className='me-2' />
                      {(t('Saving') as any) || 'جاري الحفظ...'}
                    </>
                  ) : (
                    <>
                      <i className='fas fa-plus-circle me-1'></i>
                      {(t('Add') as any) || 'إضافة'}
                    </>
                  )}
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </Card>

      {/* ✅ Table */}
      <Card className='mb-4'>
        <Loading loading={loading} error={error}>
          <div className='card-body p-0'>
            <div className='table-responsive'>
              <table className='table table-hover mb-0'>
                <thead className='bg-theme bg-opacity-30 fw-bold'>
                  <tr>
                    <th className='small'>{t('الصنف المكوّن')}</th>
                    <th className='small'>{t('الوحدة')}</th>
                    <th className='small text-end' style={{ width: '140px' }}>
                      {t('الكمية')}
                    </th>
                    <th className='small text-end' style={{ width: '120px' }}>
                      {t('الإجراءات')}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {currentList.length > 0 ? (
                    currentList.map((row: ItemComponentModels, idx: number) => {
                      const details = getItemDetails((row as any).contentItemId, (row as any).uomId);
                      const itemName =
                        i18n.language === 'en' ? (row as any)?.contentItemName : (row as any)?.contentItemName2;
                      const uomName = i18n.language === 'en' ? (row as any)?.uomName : (row as any)?.uomName2;

                      return (
                        <tr key={(row as any).id || idx}>
                          <td className='align-middle'>
                            <div className='d-flex align-items-center gap-2'>
                              <div className='fw-bold'>{itemName}</div>
                              {details?.barcode && (
                                <small className='text-muted'>
                                  <i className='fas fa-barcode me-1'></i>
                                  {details.barcode}
                                </small>
                              )}
                            </div>
                          </td>

                          <td className='align-middle'>{uomName}</td>

                          <td className='align-middle text-end'>
                            <span className='fw-bold text-primary fs-6'>
                              {Number((row as any).quantity).toFixed(0)}
                            </span>
                          </td>

                          <td className='align-middle text-end'>
                            <Button
                              variant='outline-danger'
                              size='sm'
                              onClick={() => handleDelete(row)}
                              disabled={isBusy}
                              title={t('حذف') as any}
                              className='btn-sm'
                            >
                              <i className='fas fa-trash'></i>
                            </Button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={4} className='text-center py-4 text-muted'>
                        <i className='fas fa-inbox fa-2x mb-2'></i>
                        <br />
                        {searchTerm ? t('لا توجد نتائج للبحث') : t('لا توجد مكونات مضافة')}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </Loading>

        {filteredList.length > 0 && (
          <div className='card-footer'>
            <Pagination
              filteredData={filteredList}
              dataPerPage={dataPerPage}
              handlePagination={handlePagination}
              currentPage={currentPage}
            />
          </div>
        )}
      </Card>
    </div>
  );
};

export default AssemblyComponents;
